const validatePhoneNumber = (number) => {
  if (/^[+]([0-9]{9,13})$/.test(number)) {
    return true;
  }
  return false;
};

export default validatePhoneNumber;
